<template>
    <div>
        <!-- <div id="block-1">
            <div id="inner-block">
                <b-img @click="productselected()" left :src="producto.linkimage" height="146px" alt="Left image"></b-img>
            </div>
            <div id="block-2">{{ producto.moneda }} {{ producto.precio }}</div>
            <div id="block-3">{{ producto.descripcion }}</div>
        </div> -->
        <div id="block-1">
            <div id="inner-block">
                <div v-if="productoimg && productoimg.uriImagen">
                 <b-img @click="productoImage()" left :src="productoimg.uriImagen" height="147px" alt="Left image" style="width:143px"></b-img>
                </div>
                 <div v-if="productoimg.uriImagen == null">
                <b-img @click="productoImage()" src="https://vilmanunez.com/wp-content/uploads/2015/04/herramientas-vender-online-blog.png" height="143px" alt="Left image" style="width:143px"></b-img>
                </div> 
            </div>
            <div id="block-2">{{ productoimg.moneda }} {{ productoimg.precioUnitario }}</div>
            <div id="block-3">{{ productoimg.descripcion }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['prod', 'image'],
        name: 'Producto',
        data: () => {
            return {
                producto: {},
                productoimg:{}
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init: function () {
                this.producto = this.prod
                this.productoimg = this.image
            },
            productselected: function (){
            this.$emit("productoSeleccionado", this.producto);           
          },
          productoImage(){
            this.$emit("productoImagen", this.productoimg);
          },
        }
    }
</script>

<style lang="scss" scoped>
    #block-1
    {
        border: 1px solid #ccc;
        margin: 10px;
        position: relative;
        width: 150px;
        height: 150px;
        border-radius: 5px;
        top: 1px;
        left: 1px;
        z-index: 1;
        cursor: pointer;
    }
    #inner-block
    {
        float: right;
        position: absolute;
        width: 100px;
        height: 100px;
        margin: 2px;
        z-index: 100;
    }
    #block-2
    {
        background-color: #4dbd74;
        border-radius: 5px;
        padding-left: 5px;
        color: #fff;
        font-weight: 800;
        opacity: 0.8;
        position: absolute;
        width: 88px;
        height: 20px;
        top: 1px;
        // left: 79px;
        z-index: 1000;
    }
    #block-3
    {
        padding-left: 5px;
        position: absolute;
        width: 100%;
        height: 30px;
        top: 118px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 2000;
        background-color: #000;
        color: #fff;
        opacity: 0.5;
        font-size: 11px;
    }
</style>